import React, { useState } from 'react';
import './UserSignUp.css'; 
import bgimage from "../Home/bg-image.webp"
import { useNavigate } from 'react-router-dom';

export default function UserSignUp() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobileNo: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');  // <-- error state
  const [success, setSuccess] = useState(''); // optional success message

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    setError(''); // Clear error on change
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      mobile_no: formData.mobileNo,
      password: formData.password,
      role: "Company_Admin"
    };

    try {
      const response = await fetch('http://127.0.0.1:8000/companies/user/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess('Account created successfully! You can now sign in.');
        setError('');
        setTimeout(() => {
          navigate('/UserSignin');
        }, 1500);
      } else {
        setError(data.error || 'An error occurred. Please try again.');
        setSuccess('');
      }
    } catch (err) {
      setError('Failed to sign up. Please try again.');
      setSuccess('');
    }
  };

  return (
    <div className="user-signup-container position-relative">
      <img src={bgimage} alt="Trainer background" className="user-bg-img" />

      <div className="signup-box position-absolute top-50 end-0 translate-middle-y bg-white shadow p-4 rounded">
        <div className="acharya-logo-container">
          <img width="100" height="80" src="https://acharyasol.com/images/logo.png" className="als-logo" alt="Open Learnings" />
          <div className="acharya-headlines">
            <h3>Open Learnings</h3>
          </div>
        </div>

        <h3 className="mb-4">User</h3>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="firstName" className="form-label">First Name</label>
              <input type="text" id="firstName" className="form-control" required value={formData.firstName} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="lastName" className="form-label">Last Name</label>
              <input type="text" id="lastName" className="form-control" required value={formData.lastName} onChange={handleChange} />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input type="email" id="email" className="form-control" required value={formData.email} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label htmlFor="mobileNo" className="form-label">Mobile No</label>
            <input type="text" id="mobileNo" className="form-control" required value={formData.mobileNo} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input type="password" id="password" className="form-control" required value={formData.password} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
            <input type="password" id="confirmPassword" className="form-control" required value={formData.confirmPassword} onChange={handleChange} />
          </div>

          {/* Show error message */}
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {/* Show success message */}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          <div className="d-grid mt-3">
            <button type="submit" className="btn btn-success">Sign Up</button>
          </div>
        </form>

        <div className="d-flex justify-content-between mt-4 flex-wrap">
          <small className="signup-text">
            Already have an account? <a href="/UserSignin" className="green-hover-link">Sign In</a>
          </small>
          <small className="signup-text">
            <a href="http://127.0.0.1:5500//index.html" className="green-hover-link">Home</a>
          </small>
        </div>
      </div>
    </div>
  );
}
